export const basic = [
  {
    key: 'integer_weighted_run_allowed_per_35_at_bat',
    label: '64 Rank',
    sortable: true,
    class: 'rankings-col',
  },
  { key: 'year', label: 'Year', sortable: true, class: '!text-left' },
  { key: 'team_name', label: 'School', sortable: true, class: '!text-left' },
  { key: 'conference_abbreviation', label: 'Conference', sortable: true, class: '!text-left' },
  { key: 'on_base_plus_slugging_against', label: 'OPS', sortable: true },
  { key: 'batting_average_on_balls_in_play', label: 'BABIP', sortable: true },
  { key: 'strikeouts_per_9_innings', label: 'K/9', sortable: true, direction: 'desc' },
  { key: 'strikeout_to_walk_ratio', label: 'K:BB', sortable: true, direction: 'desc' },
  { key: 'walks_plus_hits_per_inning_pitched', label: 'WHIP', sortable: true },
  { key: 'fielding_independent_pitching', label: 'FIP', sortable: true },
  { key: 'skill_interactive_earned_run_average', label: 'SIERA', sortable: true },
  { key: 'pitches_per_inning', label: 'PC/IP', sortable: true },
  { key: 'runs_allowed_ab', label: 'RA/AB', sortable: true },
  { key: 'weighted_run_allowed_efficiency', label: 'wRAE', sortable: true },
  {
    key: 'rank_weighted_run_allowed_per_35_at_bat',
    label: 'Rank',
    sortable: true,
    direction: 'desc',
  },
];
